import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import { useEffect, useState } from "react";
import useAuthStore from "store/authStore";
import axios from "axios";
import { BASE_URL } from "service";

function Earnings() {
  const { email } = useAuthStore();
  const [earnings, setEarnings] = useState(null);

  useEffect(() => {
    const fetchEarnings = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/earning/dailyselfearning/?email=${email}`
        );
        setEarnings(response.data.earnings);
      } catch (error) {
        console.error("Error fetching earnings data:", error);
      }
    };

    if (email) {
      fetchEarnings();

      console.log("earning____", earnings);
    }
  }, [email]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="error"
                icon="weekend"
                iconType="CiBank"
                title="Life Time Earning"
                count={
                  earnings?.life_time_earning
                    ? Number(earnings.life_time_earning).toFixed(2)
                    : "0.00"
                }
                percentage={{
                  color: "success",
                  amount: "+",
                  label: "Life Time Earning",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="dark"
                icon="weekend"
                iconType="PiHandWithdrawFill"
                title="Completed Withdrawals"
                count={earnings?.total_withdrawal || "0"}
                percentage={{
                  color: "success",
                  amount: "+",
                  label: "Total Withdrawal Amount",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="warning"
                icon="weekend"
                iconType="IoWalletSharp"
                title="Available Balance"
                count={
                  earnings?.available_balance
                    ? Number(earnings.available_balance).toFixed(2)
                    : "0.00"
                }
                percentage={{
                  color: "success",
                  amount: "+",
                  label: "Total Available Balance",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="leaderboard"
                iconType="GiReceiveMoney"
                title="Total Self Earning"
                count={Number(earnings?.total_self_earning || 0)
                  // +
                  // Number(earnings?.daily_direct_earning || 0) +
                  // Number(earnings?.daily_team_earning || 0)
                  .toFixed(2)}
                percentage={{
                  color: "success",
                  amount: "+",
                  label: "Total Self Earning",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="success"
                icon="store"
                iconType="TbMoneybag"
                title="Daily Earning"
                count={`Rs ${(
                  Number(earnings?.daily_self_earning || 0) +
                  Number(earnings?.daily_direct_earning || 0) +
                  Number(earnings?.daily_team_earning || 0)
                ).toFixed(2)}`}
                percentage={{
                  color: "success",
                  amount: "+",
                  label: "Life Time direct Earning",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                iconType="CiBank"
                icon="person_add"
                title="Team Earning"
                // count={earnings?.total_team_earning || "0"}
                // //ki yha pe daily_self_earning kar de gmeet ya total_team_earning || daily_total_earning
                // count={(
                //   Number(earnings?.life_time_earning) - Number(earnings?.total_self_earning)
                // ).toFixed(2)}
                // count={(
                //   Number(earnings?.total_direct_earning || 0) +
                //   Number(earnings?.total_team_earning || 0)
                // ).toFixed(2)}
                count={Math.abs(
                  Number(earnings?.life_time_earning || 0) -
                    Number(earnings?.total_self_earning || 0)
                ).toFixed(2)}
                percentage={{
                  color: "success",
                  amount: "",
                  label: "Total Team Earning",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
    </DashboardLayout>
  );
}

export default Earnings;
